/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncuestaDto } from '../../models/encuesta-dto';

export interface DoctorEncuestasControllerClonarEncuesta$Params {

/**
 * UUID de la encuesta a clonar
 */
  uuidEncuesta: string;
}

export function doctorEncuestasControllerClonarEncuesta(http: HttpClient, rootUrl: string, params: DoctorEncuestasControllerClonarEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<EncuestaDto>> {
  const rb = new RequestBuilder(rootUrl, doctorEncuestasControllerClonarEncuesta.PATH, 'post');
  if (params) {
    rb.path('uuidEncuesta', params.uuidEncuesta, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EncuestaDto>;
    })
  );
}

doctorEncuestasControllerClonarEncuesta.PATH = '/api/doctor-encuestas/clonar-encuesta/{uuidEncuesta}';
